import { RouteObject } from 'react-router-dom';
import { getTenantCrumb } from '@stores/breadCrumbStore';
import { CoreTypography } from '@youscience/core';
import { PATHWAYS_ROUTES } from '.';
import ErrorPage from '../error-page';
import { commonTenantBreadCrumbs } from './commonBreadcrumbs';

export const pathwaysRoutes: RouteObject[] = [
  {
    path: `${PATHWAYS_ROUTES.ROOT_ROUTE}/${PATHWAYS_ROUTES.PATHWAYS_MANAGEMENT}`,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        async lazy() {
          const { PathwaysManagement } = await import('@features/pathways/PathwaysManagement/PathwaysManagement');

          return { Component: PathwaysManagement };
        },
        errorElement: <ErrorPage />,
        handle: {
          crumb: () => {
            const crumbTenant = getTenantCrumb();
            const tenantId = crumbTenant?.tenantId ?? '';
            const tenantName = crumbTenant?.name ?? 'Details';

            return [
              ...commonTenantBreadCrumbs(tenantId, tenantName),
              <CoreTypography color='text.secondary'>Pathways management</CoreTypography>,
            ];
          },
        },
      },
    ],
  },
];
